module.exports = __webpack_public_path__ + "img/icon_google_G_logo.c6b7f31.svg";